import { render, staticRenderFns } from "./promise.vue?vue&type=template&id=fbb2a088&scoped=true&"
import script from "./promise.vue?vue&type=script&lang=js&"
export * from "./promise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb2a088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb2a088')) {
      api.createRecord('fbb2a088', component.options)
    } else {
      api.reload('fbb2a088', component.options)
    }
    module.hot.accept("./promise.vue?vue&type=template&id=fbb2a088&scoped=true&", function () {
      api.rerender('fbb2a088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lease/promise.vue"
export default component.exports